// トグル(アコーディオン)表示
import commonClass from "./commonClass";

export default class switchTabClass extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._$btn = $('.js-tab-l, .js-tab-r');
    this._tab = '.c-tab';
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;
    cls._$btn.on('click', function () {
      var $area_left = $(this).parents(cls._tab).find('.c-tab_cont-l');
      var $area_right = $(this).parents(cls._tab).find('.c-tab_cont-r');
      $(this).addClass('is-selected');
      $(this).siblings().removeClass('is-selected');
      if($(this).hasClass('js-tab-l')) {
        $area_left.addClass('is-show');
        $area_right.removeClass('is-show');
      }
      else {
        $area_left.removeClass('is-show');
        $area_right.addClass('is-show');
      }
    });
  }

}